<div class="lines shine"></div>